import { useAppState } from "Context/StateContext";
import { ResourceFunction, RolePermissionsResponse, RoleResource } from "Models/resources";
import { Roles } from "Models/user";
import { useState } from "react";
import { ResourceObjectTypeEnum } from "Util/enums/accessRule";
import { useAccessRuleDrawerActions } from "./useAccessRuleDrawerActions";

export const useAccessRuleDrawerStates = () => {
  const [isOpenAccessRuleDrawer, setIsOpenAccessRuleDrawer] = useState<boolean>(false);
  const [functionPermissions, setFunctionPermissions] = useState<ResourceFunction[]>([]);
  const [masterDataPermissions, setMasterDataPermissions] = useState<ResourceFunction[]>([]);
  const [accessRule, setAccessRule] = useState<Roles>();
  const [roleResources, setRoleResources] = useState<RoleResource[]>([]);
  const { currentUser } = useAppState();

  const { getAccesRules } = useAccessRuleDrawerActions();

  getAccesRules({
    enabled: isOpenAccessRuleDrawer && !!currentUser?.id && !!accessRule?.id,
    accessRuleId: accessRule?.id,
    onSuccess(data) {
      let resourcePermissions: RoleResource[] = [];
      let functionPermissions: ResourceFunction[] = [];
      let dataPermissions: ResourceFunction[] = [];


      data?.forEach((permission: RolePermissionsResponse) => {

        if (permission.id === 83) console.log("PERMISSION",permission)
        // if (permission?. === "Confirmation of accessorial services provided") {
        //   console.log(permission)
        // }

        if (permission?.objectType === ResourceObjectTypeEnum.RESOURCE) {
          resourcePermissions.push({
            id: permission?.objectDetails?.id ?? 0,
            resourceId: permission?.objectDetails?.resourceId ?? 0,
            edit: permission?.canEdit === 1,
            view: permission?.canView === 1,
            add: false,
            delete: false,
          });
        }

        if (
          permission?.objectType === ResourceObjectTypeEnum.FUNCTION &&
          (!permission?.objectDetails?.objectData || permission?.objectDetails?.objectData === "")
        ) {
          functionPermissions.push({
            ...permission?.objectDetails,
            resourceId: permission?.resourceId,
            checked: true,
            objectType: ResourceObjectTypeEnum.FUNCTION,
          });
        }

        if (
          permission?.objectType === ResourceObjectTypeEnum.FUNCTION &&
          permission?.objectDetails?.objectData &&
          permission?.objectDetails?.objectData !== ""
        ) {
          dataPermissions.push({
            ...permission?.objectDetails,
            resourceId: permission?.resourceId,
            checked: true,
            objectType: ResourceObjectTypeEnum.FUNCTION,
          });
        }
      });
      setRoleResources(resourcePermissions);
      setFunctionPermissions(functionPermissions);
      setMasterDataPermissions(dataPermissions);
    },
  });

  return {
    accessRule,
    setAccessRule,
    roleResources,
    setRoleResources,
    functionPermissions,
    masterDataPermissions,
    isOpenAccessRuleDrawer,
    setIsOpenAccessRuleDrawer,
    setFunctionPermissions,
    setMasterDataPermissions,
  };
};
